import {
	Button,
	Input,
	InputNumber,
	message,
	Modal,
	Popconfirm,
	Select,
} from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import baseuri from '../../methods/baseuri';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	getBlockchainNetworks,
	getCurrencies,
} from '../../methods/redux/reducers/currency';
import { commas } from '../../methods/utils/general-utils';

const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1em;
`;
export const MyButton = styled.button`
	border: none;
	background: transparent;
	display: flex;
	align-items: center;
	cursor: pointer;
	font-size: 12px;
	/* padding: 8px 12px 8px 5px; */
	border-radius: 25px;
	transition: background 400ms ease;
	margin-top: 10px;

	&:hover {
		background: #e2e2e2;
	}
`;
const MyModal = styled(Modal)`
	border-radius: 10px;
	overflow: auto;
`;

interface ICreateAdvertBanner {
	// eslint-disable-next-line react/require-default-props
	details?: any | null;
}
const CreateCryptoWithdrawal: FC<ICreateAdvertBanner> = ({ details }) => {
	// const { user } = useSelector((store: any) => store.auth);
	const { cryptoBalances } = useAppSelector(
		(store) => store.general
	);

	const [visible, setVisible] = useState(false);
	const [loading, setloading] = useState(false);
	const [data, setData] = useState({
		userId: details?.profile?._id || '',
		currencyId: '',
		amount: '0',
		blockchainNetworkId: '',
		destinationAddress: '',
		blockchainMemo: details.profile.blockchainWalletMemo || '',
		comment: '',
		code: '',
	} as any);



	const handleCreate = async () => {
		try {
			setloading(true);
			const res: any = await baseuri.post(
				`admin/wallet/trigger-withdrawal/crypto`,
				data
			);

			if (res.status === 200) {
				setVisible(false);
				setloading(false);
				message.success(res.data.message);
			} else {
				setloading(false);
				message.info(res.data.message);
			}
		} catch (e: any) {
			setloading(false);
			message.error(e.response.data.message);
		}
	};

	const dispatch = useAppDispatch();
	const { currencies } = useAppSelector((store: any) => store.currencies);
	const { blockchains } = useAppSelector((store) => store.currencies);
	useEffect(() => {
		if (currencies.length < 1) {
			dispatch(getCurrencies({}));
		}
		if (blockchains.length < 1) {
			dispatch(getBlockchainNetworks());
		}
	}, []);

	// balances for the currently selected currency
	const filteredCryptoBalances = data.currencyId
		? cryptoBalances.filter((b: any) => b?.currencyId?._id === data.currencyId)
		: [];

	const totalFilteredCryptoBalance = filteredCryptoBalances.reduce(
		(s: number, cur: any) => s + Number(cur.balance || 0),
		0
	);
     console.log(details?.profile, 'details?.profile');
	const amountNumber = Number(data?.amount) || 0;
	const isAmountValid = Boolean(
		data.currencyId && amountNumber > 0 && amountNumber <= totalFilteredCryptoBalance
	);

	return (
		<div>
			<Button onClick={() => setVisible(true)} icon={<SendOutlined />}>
				Trigger Blockchain Withdrawal
			</Button>
			<MyModal
				title={`Initiate Blockchain Withdrawal On-Behalf Of - ${
					details?.profile?.username ?? ''
				}`}
				visible={visible}
				footer={[
					<Popconfirm
						title="Are you sure?"
						onConfirm={handleCreate}
						disabled={!isAmountValid}
					>
						<Button loading={loading} type="primary" disabled={!isAmountValid}>
							Remit
						</Button>
					</Popconfirm>,
				]}
				onCancel={() => setVisible(false)}
			>
				{' '}
				<ModalContent>
					{/* {cryptoBalances.length > 0 && cryptoBalances.map((currency: any) => {
                        return (
                            <div key={currency.currencyId._id}>
                                <p>Currency: {currency.currencyId.name} , Balance: {currency.balance}</p>
                            </div>
                        )
                    })} */}
					<p>
						UserId :{' '}
						<Input
							placeholder="input Title"
							value={data?.userId}
							defaultValue={details?.profile?._id || ''}
							onChange={(e: any) =>
								setData({ ...data, userId: e.target.value })
							}
						/>
					</p>

					<p>
						<h3>Currencies</h3>
						<Select
							// value={searchParams.get('currencyId') || defaultData.value}
							placeholder="Select Currency"
							style={{ width: '100%' }}
							onChange={(value: string) =>
								setData({ ...data, currencyId: value })
							}
						>
							{currencies?.map((optionItem: any) => (
								<Select.Option key={optionItem.name} value={optionItem._id}>
									{optionItem.name}
								</Select.Option>
							))}
						</Select>
					</p>

					<p>
						<p>Amount :</p>
						<InputNumber
							style={{ width: '100%' }}
							placeholder="input Amount"
							value={Number(data?.amount)}
							onChange={(e: any) => setData({ ...data, amount: `${e}` })}
							stringMode
						/>
					</p>
					{data.currencyId && (
						<>
							<p style={{ color: 'green' }}>
								<strong>Total available: </strong>
								{commas(totalFilteredCryptoBalance)}{' '}
								{filteredCryptoBalances[0]?.currencyId?.symbol || ''}
							</p>
							{amountNumber > totalFilteredCryptoBalance && (
								<p style={{ color: '#ff4d4f' }}>
									Amount exceeds available balance
								</p>
							)}
						</>
					)}
					<p>
						<p>Comment</p>
						<textarea
							placeholder="input message"
							style={{ width: '100%' }}
							value={data?.comment}
							onChange={(e: any) =>
								setData({ ...data, comment: e.target.value })
							}
						/>
					</p>

					<p>
						<h3>Blockchain Network</h3>
						<Select
							// value={searchParams.get('currencyId') || defaultData.value}
							placeholder="Select Blockchain Network"
							style={{ width: '100%' }}
							onChange={(value: string) =>
								setData({ ...data, blockchainNetworkId: value })
							}
						>
							{blockchains?.map((optionItem: any) => (
								<Select.Option key={optionItem.name} value={optionItem._id}>
									{optionItem.name}
								</Select.Option>
							))}
						</Select>
					</p>
					<p>
						Destination Address :{' '}
						<Input
							placeholder="input Destination Address"
							value={data?.destinationAddress}
							onChange={(e: any) =>
								setData({ ...data, destinationAddress: e.target.value })
							}
						/>
					</p>
					{/* <p>
						Blockchain Memo :{' '}
						<Input
							placeholder="Blockchain Memo Id"
							value={data?.blockchainMemo}
							onChange={(e: any) =>
								setData({ ...data, blockchainMemo: e.target.value })
							}
						/>
					</p> */}
					<p>
						2FA Code :{' '}
						<Input
							placeholder="input 2FA Code"
							value={data?.code}
							onChange={(e: any) => setData({ ...data, code: e.target.value })}
						/>
					</p>
				</ModalContent>
			</MyModal>
		</div>
	);
};

export default CreateCryptoWithdrawal;
